/**
 * MapLibre line layer paint for road risk score choropleth.
 * Color stops are normalized 0..1 against metadata.maxRiskScore at bind time.
 * Palette: green (low) → yellow → orange → red (high).
 */
export const RISK_MAP_COLOR_STOPS = [
  { t: 0, color: 'rgb(34, 139, 34)' },
  { t: 0.33, color: 'rgb(234, 179, 8)' },
  { t: 0.66, color: 'rgb(234, 120, 20)' },
  { t: 1, color: 'rgb(220, 38, 38)' },
]

/** CSS gradient matching {@link RISK_MAP_COLOR_STOPS} for the map legend. */
export const RISK_MAP_LEGEND_GRADIENT =
  'linear-gradient(90deg, rgb(34, 139, 34), rgb(234, 179, 8), rgb(234, 120, 20), rgb(220, 38, 38))'

export function buildRoadRiskMapLayer(maxRiskScore = 1) {
  const max = Number.isFinite(maxRiskScore) && maxRiskScore > 0 ? maxRiskScore : 1

  const lineColor = ['interpolate', ['linear'], ['get', 'riskScore']]
  for (const stop of RISK_MAP_COLOR_STOPS) {
    lineColor.push(max * stop.t, stop.color)
  }

  return {
    id: 'road-risk-map',
    type: 'line',
    layout: {
      'line-join': 'round',
      'line-cap': 'round',
    },
    paint: {
      'line-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        8, 3.5,
        14, 7,
        18, 11,
      ],
      'line-opacity': 0.9,
      'line-color': lineColor,
    },
  }
}

export const roadRiskMapHitLayer = {
  id: 'road-risk-map-hit',
  type: 'line',
  paint: {
    'line-width': 14,
    'line-opacity': 0,
    'line-color': '#000000',
  },
}

/** Neutral gray underlay for all filtered road segments in the bbox. */
export const roadNetworkUnderlayLayer = {
  id: 'road-network-underlay',
  type: 'line',
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
  paint: {
    'line-width': [
      'interpolate',
      ['linear'],
      ['zoom'],
      8, 0.4,
      14, 1,
      18, 1.5,
    ],
    'line-opacity': 0.85,
    'line-color': '#1F2937',
  },
}

export const roadNetworkUnderlayHitLayer = {
  id: 'road-network-underlay-hit',
  type: 'line',
  paint: {
    'line-width': 14,
    'line-opacity': 0,
    'line-color': '#000000',
  },
}
